export default __webpack_public_path__ + "static/media/E.ee364489.svg";